import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=459b1d48&scoped=true"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"
import style0 from "./Story.vue?vue&type=style&index=0&id=459b1d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b1d48",
  null
  
)

/* custom blocks */
import block0 from "./Story.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports